import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import axios from "axios";
import { ENDPOINTS } from "../../constants/endpoints.constant";

export type BankList = {
  status: boolean;
  message: string;
  data: {
    data: {
      masked_account_number: string;
      bank_name: string;
      ifsc_code: string;
      id: string;
    }[];
  };
};

export const fetchMyBankData = createAsyncThunk<BankList, { id: string }>(
  "banklist/fetchMyBankData",
  async ({ id }) => {
    const res = await axios.get<BankList>(
      import.meta.env.VITE_APP_API_URL + "/" + ENDPOINTS.bank_list,
      {
        params: { limit: -1, event_id: id },
        withCredentials: true,
      }
    );
    return res.data;
  }
);

type BankState = {
  data: BankList | null;
  loading: boolean;
  error: string | null;
};

const initialState: BankState = {
  data: null,
  loading: false,
  error: null,
};

const bankListSlice = createSlice({
  name: "banklist",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchMyBankData.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(
        fetchMyBankData.fulfilled,
        (state, action: PayloadAction<BankList>) => {
          state.loading = false;
          state.data = action.payload;
        }
      )
      .addCase(fetchMyBankData.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Unknown error";
      });
  },
});

export default bankListSlice.reducer;
